'use client'

import { ThemeProvider } from 'next-themes'
import { usePathname } from 'next/navigation'
import { PORTAL_THEME_CONFIG, portalSupportsTheme } from '@/lib/ui/theme'

export default function PortalThemeProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname()
  return (
    <ThemeProvider {...PORTAL_THEME_CONFIG}
      forcedTheme={portalSupportsTheme(pathname) ? undefined : 'dark'}>
      {children}
    </ThemeProvider>
  )
}
